import React from 'react';

const Loading = ({ message = 'กำลังโหลด...' }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br  flex items-center justify-center">
      <div className="text-center">
        {/* Animated spinner */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-white/20"></div>
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-white animate-spin"></div>
          <div className="absolute inset-3 rounded-full border-4 border-transparent border-t-pink-300 animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1s' }}></div>
        </div>

        {/* Loading text */}
        <p className="text-white text-xl font-semibold">{message}</p>

        {/* Animated dots */}
        <div className="flex justify-center gap-1 mt-4">
          <span className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      </div>
    </div>
  );
};

export default Loading;